module.exports = __webpack_public_path__ + "static/media/wellbeing-foundations-large.4af82cf0.png";